export default __webpack_public_path__ + "static/media/4.7e9dc5c8.png";